import React, { useState } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, } from '@mui/material';
import { createDownloadLink } from '../../../../utils/utils';
import ViewPDF from '../../../../components/pdfviewer/viewpdf';

const PrescriptionController = ({url}) => {
    const matches = url.match(/\.([^.]+)$/);
    const [openViewer, setOpenViewer] = useState(false);
    const toggleReportViewer = (toggle) => () => {
            setOpenViewer(toggle);
    };
    const downloadReport = () => {
        createDownloadLink(url);
    };
    const viewImage = (
      <div className='img-report-container'>
          <img src={url} alt="report_file" />
      </div>
    );
    const viewPdf = matches[1] === 'pdf' ? <ViewPDF file={url} /> : viewImage;
    const pdfViewer = openViewer && (
        <Dialog open={openViewer} maxWidth='md' fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>View Report</div>
                <IconButton size='small' onClick={toggleReportViewer(false)}>
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {viewPdf}
            </DialogContent>
        </Dialog>
    );
    return (
      <>
        {pdfViewer}
        <div className='flex-gap'>
          <Button color="primary" variant="contained" onClick={toggleReportViewer(true)} title='View Prescription'> <VisibilityIcon style={{fill: 'white'}} /> </Button>
          <Button color="primary" variant="contained" onClick={downloadReport} title='Download Prescription' > <DownloadIcon style={{fill: 'white'}} /> </Button>
        </div>
      </>
    );
  };

  export default PrescriptionController;

  PrescriptionController.propTypes = {
    url: PropTypes.string.isRequired,
  };